import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios"
export default function ReplacePA(props) {

    const params = useParams();
    const id = params.id
    console.log("PARAMS ", params)
    const [quartierName, setQuartierName] = useState("")
    const [polygones, setPolygone] = useState("")
    const [detectedPolygones, setDetectedPolygones] = useState({
        "type": "FeatureCollection",
        "features": []
    })
    const [validating, setValidating] = useState(false)
    const [validatingQuartier, setValidatingQuartier] = useState(false)
    const [error, setError] = useState("")
    const [quartierToValidate, setQuartierToValidate] = useState(0)
    const [validatingRecoupement, setValidatingRecoupement] = useState(false)
    const [validatingRGC, setValidatingRGC] = useState(false)
    const [validatingAdding, setValidatingAdding] = useState(false)
    const [validatingMAJ, setValidatingMAJ] = useState(false)
    const [recoupementErrors, setRecoupementErrors] = useState({})
    const [updatingAgenzData, setUpdatingAgenzData] = useState({})
    const [rgc, setRGC] = useState({})
    const [added, setAdded] = useState({})
    const [maj, setMaj] = useState({})
    useEffect(() => {
        console.log("recoupementErrors ", recoupementErrors)
    }, [recoupementErrors])
    const validateRecoupement = (item, key) => {
        console.log(item)
        return (new Promise((resolve, reject) => {
            axios.post("https://core.agenz.ma/api/cartographie/ajoutpa/intersects", {
                geometry: item,
                avoid_id: id
            })
                .then(res => {
                    console.log(res.data)
                    if (res.data.data.length) {
                        let newrecoupementErrors = { ...recoupementErrors }
                        newrecoupementErrors[key] = res.data.data
                        setRecoupementErrors(newrecoupementErrors)
                        resolve(true)
                        // setValidatingRecoupement(true)
                    }
                    else {
                        let newrecoupementErrors = { ...recoupementErrors }
                        newrecoupementErrors[key] = res.data.data
                        setRecoupementErrors(newrecoupementErrors)
                        resolve(true)
                    }
                })
                .catch(err => {
                    console.log(err)
                    reject(false)
                    // setValidatingRecoupement(true)

                })

            // resolve(true)
        }))

    }

    const validateRGC = (item, key) => {
        return (new Promise((resolve, reject) => {
            setValidatingRGC(true)
            axios.post("https://core.agenz.ma/api/cartographie/ajoutpa/rgc",
                item

            )
                .then(res => {
                    console.log(res.data)
                    let new_rgc = { ...rgc }
                    new_rgc[key] = res.data.data
                    setRGC(new_rgc)
                    resolve(res.data.data)
                })
                .catch(err => {
                    console.log(err)
                    reject(err)
                })
        }))

    }
    const validateAdding = (item, key, rgc_data) => {
        return (new Promise((resolve, reject) => {
            axios.post("https://core.agenz.ma/api/cartographie/ajoutpa/majoldpa",
                { "pa_id": id }
            )
                .then(res => {
                    console.log(res.data)
                    console.log(key)
                    console.log(rgc_data)
                    axios.post("https://core.agenz.ma/api/cartographie/ajoutpa/addpa",
                        {
                            "pa_geometry": item,
                            "quartier_name": quartierName,
                            "commune": rgc_data.commune,
                            "province": rgc_data.province,
                            "region": rgc_data.region
                        }
                    )
                        .then(res => {
                            console.log(res.data)
                            let new_added = { ...added }
                            new_added[key] = true
                            setAdded(new_added)
                            resolve("done")

                        })
                        .catch(err => {
                            reject(err)
                            console.log(err)
                        })
                })
                .catch(err => {
                    reject(err)
                    console.log(err)
                })
            resolve(true)
        }))

    }
    const validateMAJ = (item, key) => {
        return (new Promise((resolve, reject) => {
            axios.post("https://core.agenz.ma/api/cartographie/ajoutpa/majannonces",
                {
                    "pa_geometry": item,
                    "quartier_name": quartierName
                }).then(res => {
                    axios.post("https://core.agenz.ma/api/cartographie/ajoutpa/majestimations",
                        {
                            "pa_geometry": item,
                            "quartier_name": quartierName
                        }).then(res => {
                            let new_maj = { ...maj }
                            new_maj[key] = true
                            setMaj(new_maj)
                            resolve("done")
                        })
                        .catch(err => {
                            reject(err)
                            console.log(err)
                        })
                })
                .catch(err => {
                    reject(err)
                    console.log(err)
                })

        }))

    }
    const validatePolygones = () => {
        setValidating(true)
        try {
            console.log(polygones)

            console.log("JSON.parse(polygones) ", JSON.parse(polygones))
            setDetectedPolygones(JSON.parse(polygones))
            setValidating(false)
            setError("")

        }
        catch (e) {
            console.log(e)
            setError(e)
            setValidating(false)
        }
    }
    const addQuartierAndUpdate = (item, key) => {
        let new_updating = { ...updatingAgenzData }
        new_updating[key] = true
        setUpdatingAgenzData(new_updating)
        let rgc_done = false
        let adding_done = false
        let maj_done = false
        validateRGC(item, key).then((res) => {
            console.log("RGC done ")
            validateAdding(item, key, res).then(() => {
                validateMAJ(item, key).then(() => {
                    alert(`Tout est ok pour ${quartierName}`)
                    setQuartierToValidate(quartierToValidate + 1)
                    setValidatingQuartier(false)

                }).catch(err => {
                    alert("Impossible d'ajouter le quartier")

                    setQuartierToValidate(quartierToValidate + 1)

                })
            }).catch(err => {
                let new_updating = { ...updatingAgenzData }
                new_updating[key] = false
                setUpdatingAgenzData(new_updating)
                setValidatingQuartier(false)
                setQuartierToValidate(quartierToValidate + 1)

                alert("Impossible d'ajouter le quartier")
            })

        }).catch(err => {
            console.log(err)
            rgc_done = false
            let new_updating = { ...updatingAgenzData }
            new_updating[key] = false
            setUpdatingAgenzData(new_updating)
            setValidatingQuartier(false)
            alert("Impossible de récupérer la region, commune, province de ce quartier")


        })


    }
    const valdateQuartierName = (item, key) => {
        console.log("valdateQuartierName ", item, key)
        setValidatingQuartier(true)
        let recoupement_done = false

        validateRecoupement(item, key).then(() => {
            recoupement_done = true
            setValidatingQuartier(false)
        }).catch(err => {
            recoupement_done = true
            setValidatingQuartier(false)
            console.log(err)
        })




    }
    return (
        <div className={"replace_pa_container"}>
            <div className={"replace_pa_inner"}>
                {/* <div className={"input_container"}>
                <label htmlFor="name" className={"quartier_name_label"}>Nom du nouveau quartier </label>
                <input id="name" className={"quartier_name"} type="text" value={quartierName} onChange={(e)=>{
                    setQuartierName(e.target.value)
                }} />
                </div> */}
                <div className={"input_container"}>
                    <label htmlFor="polygones" className={"quartier_label"}>Copiez/collez les nouveaux polygones </label>
                    <textarea id="polygones" className={"quartier_name"} type="text" value={polygones} onChange={(e) => {
                        console.log("E ", e)
                        setPolygone(e.target.value)
                    }} />
                    {error ? (
                        <p className="error">Vérifier le format : {error.toString()} </p>
                    ) : null}
                </div>

                <div className={"input_container"}>
                    {validating ? (
                        <button className={"validate_polygones"}><i className="fas fa-circle-notch fa-spin"></i></button>


                    ) : (
                        <button onClick={() => {
                            validatePolygones()
                        }}
                            className={"validate_polygones"}>Valider 1</button>
                    )}

                </div>
                <div className={"input_container"}>
                    <p className={"detected_polygones"}>{detectedPolygones.features.length} polygone(s) détecté(s)</p>
                    {detectedPolygones.features.map((item, key) => {
                        return (
                            <div key={key} className={"input_container"}>
                                <div className={"input_container"}>
                                    <p className={"quartier_number"} >Quartier n° {key + 1}</p>
                                    <label htmlFor="name" className={"quartier_name_label"}>Nom du nouveau quartier </label>
                                    <input disabled={quartierToValidate < key} id="name" className={"quartier_name"} type="text" value={quartierName} onChange={(e) => {
                                        setQuartierName(e.target.value)
                                    }} />
                                    <a className={"quartier_check"} href={
                                        `http://geojson.io/#data=data:application/json,${encodeURIComponent(JSON.stringify({
                                            "type": "Feature",
                                            "properties": {},
                                            "geometry": item.geometry
                                        }))}`
                                    } target="__blank" >Voir le quartier</a>

                                    {validatingQuartier ? (
                                        <button className={"validate_polygones"}><i className="fas fa-circle-notch fa-spin"></i></button>
                                    ) : (
                                        <button disabled={quartierToValidate !== key} className={quartierToValidate !== key ? "disabled_button" : "validate_polygones"} onClick={() => { valdateQuartierName(item.geometry, key) }}>{quartierToValidate > key ? "Déjà validé" : "Valider 2"}</button>
                                    )}
                                    <div className={"input_container"}>
                                        {validatingQuartier && quartierToValidate == key ? (

                                            <div className={"validation__container"}>
                                                <p className={"validation_title"}>Vérification du recoupement
                                                    {recoupementErrors[key] ? recoupementErrors[key].length ? " ERREUR ! " : " OK !" : <i className="fas fa-circle-notch fa-spin"></i>}</p>
                                            </div>
                                        ) : null}
                                        {recoupementErrors[key] ? (
                                            <div className={"input_container"}>
                                                <p className={"validation_title"}>Recoupent avec {recoupementErrors[key].length} quartier(s) </p>
                                                <a href={
                                                    `http://geojson.io/#data=data:application/json,${encodeURIComponent(JSON.stringify({
                                                        "type": "FeatureCollection",
                                                        "features": recoupementErrors[key].map(item => {
                                                            return ({
                                                                "type": "Feature",
                                                                "properties": {
                                                                    "stroke": "#555555",
                                                                    "stroke-width": 2,
                                                                    "stroke-opacity": 1,
                                                                    "fill": "#da1616",
                                                                    "fill-opacity": 0.5,
                                                                    "province": item.province,
                                                                    "quartier": item.quartier,
                                                                },
                                                                "geometry": item.geometry
                                                            })
                                                        }).concat([{
                                                            "type": "Feature",
                                                            "properties": {},
                                                            "geometry": item.geometry
                                                        }])
                                                    }))}`} className={"validation_title"} target="__blank">Voir les quartiers qui recoupent </a>

                                                <button className={"validate_polygones error_validate"} onClick={() => { window.location.reload() }}>Je recommence</button>
                                                <button className={"validate_polygones"} onClick={() => {
                                                    let newrecoupementErrors = { ...recoupementErrors }
                                                    newrecoupementErrors[key] = []
                                                    setRecoupementErrors(newrecoupementErrors)
                                                }}>Valider quand même</button>

                                            </div>
                                        ) : null}

                                        {updatingAgenzData[key] ? (
                                            <>
                                                <div className={"validation__container"}>
                                                    <p className={"validation_title"}>Vérification de la commune region province ...
                                                        {
                                                            rgc[key] ? (
                                                                <span> Region : {rgc[key].region} - province : {rgc[key].province} - commune : {rgc[key].commune} </span>
                                                            ) : (
                                                                <i className="fas fa-circle-notch fa-spin"></i>
                                                            )


                                                        }</p>
                                                </div>
                                                <div className={"validation__container"}>
                                                    <p className={"validation_title"}>Ajout du nouveau quartier ... {
                                                        added.key ? (
                                                            <span> OK ! </span>
                                                        ) : (

                                                            <i className="fas fa-circle-notch fa-spin"></i>)
                                                    }
                                                    </p>
                                                </div>
                                                <div className={"validation__container"}>
                                                    <p className={"validation_title"}>Mise à jour des bases de données ... {
                                                        maj[key] ? (
                                                            <span>Done </span>
                                                        ) : (<i className="fas fa-circle-notch fa-spin"></i>)} </p>
                                                </div>
                                            </>
                                        ) :

                                            null

                                        }

                                    </div>
                                    <button onClick={() => {
                                        console.log("recoupementErrors ", recoupementErrors)
                                        if (recoupementErrors[key]) {
                                            if (recoupementErrors[key].length) {
                                                return;
                                            }
                                            else {
                                                addQuartierAndUpdate(item, key);
                                            }
                                        } else {
                                            return;
                                        }
                                    }} className={!recoupementErrors[key] ? "disabled_button" : recoupementErrors[key].length ? "disabled_button" : "validate_polygones"}> {!recoupementErrors[key] ? "Vérifiez d'abord le recoupement" : recoupementErrors[key].length ? "Vérifiez d'abord le recoupement" : "Valider le quartier et mettre à jour les données"} </button>
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>
        </div >
    )

}